<template>
  <div>
    <div class="bg-overlay"></div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navigation-example-2"
            @click="toggleNavbar">
            <span class="sr-only">{{ $t("toggle_navigation") }}</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <img src="static/img/logo.svg" class="login-logo" />
        </div>
        <div class="col-md-4 social-buttons-header hidden-sm">
          
          <a class="gb-button gb-button-2231f389" href="https://www.facebook.com/profile.php?id=61558225554317" target="_blank"
            rel="noopener noreferrer"><span class="gb-icon"><svg aria-hidden="true" height="1em" width="1em"
                viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor"
                  d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z">
                </path>
              </svg></span></a>

          <a class="gb-button gb-button-75be2872" href="https://www.instagram.com/kocalibration/" target="_blank"
            rel="noopener noreferrer"><span class="gb-icon"><svg aria-hidden="true" height="1em" width="1em"
                viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor"
                  d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
                </path>
              </svg></span></a>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link :to="{ name: 'Home' }" tag="li">
              <a> <i class="fas fa-home"></i> {{ $t("dashboard") }} </a>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color :data-image="shuffledImage">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#" @submit.prevent="doLogin">
                  <div class="card login-card">
                    <div class="card-header">
                      <h4>Please login</h4>
                    </div>
                    <div class="card-content">                      
                      <div class="form-group">
                        <label>{{ $t("email_address") }}</label>
                        <input type="email" name="email" v-model="email" placeholder="Enter email"
                          class="form-control input-no-border" v-validate="'required'" />
                        <small class="text-danger" v-show="getError('email')">{{
                          getError("email")
                        }}</small>
                      </div>
                      <div class="form-group">
                        <label>{{ $t("password") }}</label>
                        <input type="password" name="password" v-model="password" placeholder="Password"
                          class="form-control input-no-border" v-validate="'required|min:4'" />
                        <small class="text-danger" v-show="getError('password')">{{ getError("password") }}</small>
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <span v-if="loginFailed" class="text-warning">
                        <i class="fas fa-exclamation-triangle"></i>
                        {{ $t("login_failed_try_or_reset") }}.<br /><br />
                      </span>
                      <button type="submit" :disabled="loading" class="btn btn-electr btn-wd">
                        <i class="fas" :class="{
                          'fa-sign-in-alt': !loading,
                          'fa-atom fa-spin': loading,
                        }"></i>
                        {{ $t("lets_go") }}
                      </button>
                      <br />
                      <br />
                      <div class="forgot">
                        <router-link to="/register"><i class="fas fa-pen"></i>
                          {{ $t("create_account") }}</router-link>
                        or
                        <router-link to="/password-forgot"><i class="fas fa-question-circle"></i>
                          {{ $t("forgot_your_password") }}?</router-link>
                      </div>
                      <div v-if="showVerificationResendButton"><br />
                        <div class="btn btn-xs btn-electr btn-wd" @click="resendVerificationMail()">
                          <i class="fas fa-user-check"></i> {{ $t('resend_verification_email') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="full-page-background" :style="{ backgroundImage: 'url(' + shuffledImage + ')' }"
          style="'background:no-repeat center center fixed;'"></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>{{ $t("register") }}</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>{{ $t("dashboard") }}</a>
        </router-link>
      </ul>
    </div>
    <div class="login-page-footer navbar">
      <div class="login-page-footer-container">
        {{ 'now' | dateFilter('YYYY') }} © <a
         :href="ws.getSetting('domain')">
          {{ ws.getSetting('name') }}
      </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vee-validate";
export default {
  props: ["logout"],
  computed: {
    ...mapFields(["email", "password"]),
  },
  data() {
    return {
      email: "",
      password: "",
      shuffledImage: "",
      loginFailed: false,
      loading: false,
      logo: "",
      email_verification_code: "",
      verification_email: "",
      showVerificationResendButton: false
    };
  },
  mounted() {
    Webservice.checkBrowser();
    this.imageShuffler();
    this.loadLogo();
    this.email_verification_code = this.$route.query.email_verification_code;
    this.verification_email = this.$route.query.email;

    if (this.logout) {
      this.loading = true;
      Webservice.logout().then((resp) => {
        if (resp.data.message == "success") {
          this.$notify({
            component: {
              template: `<span>` + $t("logged_out") + `!</span>`,
            },
            icon: "ti-info",
            type: "success",
          });
        }
        this.loading = false;
      });
    }

    if (this.email_verification_code && this.verification_email) {
        Webservice.verifyEmail(this.email_verification_code, this.verification_email).then((resp) => {
          if (resp.data == 'error_token_invalid') {
            this.showVerificationResendButton = true;
            this.$notify({
              component: {
                template: `<span>` + this.$t("email_verification_failed_token_invalid") + `!</span>`,
              },
              icon: "ti-error",
              type: "warning",
            });
          }
          else if (resp.data == 'already_verified') {
            this.$notify({
              component: {
                template: `<span>` + this.$t("sorry_this_address_is_already_verified") + `</span>`,
              },
              icon: "ti-info",
              type: "warning",
            });
          } else {
            this.$notify({
              component: {
                template: `<span>` + this.$t("email_verified_succesfully") + `!</span>`,
              },
              icon: "ti-info",
              type: "success",
            });
          }
        }).catch((err) => {
          this.$notify({
              component: {
                template: `<span>` + this.$t("something_went_wrong_verifying") + `</span>`,
              },
              icon: "ti-info",
              type: "error",
            });
        })
      }
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    loadLogo() {
      var logo = Ls.get("opts.logo");
      if (logo) {
        this.logo = logo;
      }
    },
    resendVerificationMail() {
      if (!this.email) {
        this.$notify({
          component: {
            template: `<span>` + this.$t("please_enter_your_email_address_first") + `!</span>`,
          },
          icon: "ti-info",
          type: "warning",
        });
      } else {
        Webservice.resendVerificationEmail(btoa(this.email)).then((resp) => {
          if (resp.data) {
            if (resp.data == 'already_verified') {
              this.$notify({
                component: {
                  template: `<span>` + this.$t("sorry_this_address_is_already_verified") + `</span>`,
                },
                icon: "ti-info",
                type: "warning",
              });
            } else {
              this.$notify({
                component: {
                  template: `<span>` + this.$t("logged_in") + `!</span>`,
                },
                icon: "ti-info",
                type: "success",
              });
            }
          }
        }).catch((err) => {

        });
      }
    },
    doLogin() {
      this.$validator.validateAll().then((result) => {
        this.loginFailed = false;
        if (!result) {
        } else {
          this.loading = true;
          Webservice.login(this.email, this.password)
            .then((resp) => {
              if (resp === true) {
                this.$notify({
                  component: {
                    template: `<span>` + this.$t("logged_in") + `!</span>`,
                  },
                  icon: "ti-info",
                  type: "success",
                });
                setTimeout(() => {
                  this.$router.push({ path: "portal/home" });
                }, 150);
              }
            })
            .catch((error) => {
              this.loading = false;
              this.loginFailed = true;
              if (error.response.data.error.includes('EmailUnverified')) {
                this.showVerificationResendButton = true;
                this.$notify({
                  component: {
                    template:
                      "<span>" +
                      this.$t("error_login_email_unverified") +
                      "</span>",
                  },
                  icon: "fas fa-user-check",
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "warning",
                });
              } else {
                this.showVerificationResendButton = false;
                this.$notify({
                  component: {
                    template:
                      "<span>" +
                      this.$t("sorry_login_failed_check_credentials") +
                      "</span>",
                  },
                  icon: "fas fa-exclamation-triangle",
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "warning",
                });
              }
            });
        }
      });
    },
    imageShuffler() {
      var images = ["static/img/background/background-1.jpg", "static/img/background/background-2.jpg", "static/img/background/background-3.jpg", "static/img/background/background-4.jpg", "static/img/background/background-5.jpg", "static/img/background/background-6.jpg"];
      var shuffled = images[Math.floor(Math.random() * images.length)];
      if (!this.shuffledImage) {
        this.shuffledImage = "'" + shuffled + "'";
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
  computed: {
    ws: () => {
      return Webservice;
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue